// extracted by mini-css-extract-plugin
module.exports = {"paper":"DialogPopup_paper__1dYa6","paper_big":"DialogPopup_paper_big__1aYQc","popup_header":"DialogPopup_popup_header__4kxpp","popup_content":"DialogPopup_popup_content__NX0Ku"};